import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {IonicModule} from '@ionic/angular';
import {DocumentDownloadComponent} from './document-download.component';
import {DownloadButtonModule} from '../../../../../core/component/download-button/download-button.module';

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        DownloadButtonModule,
    ],
    declarations: [
        DocumentDownloadComponent,
    ],
    exports: [
        DocumentDownloadComponent
    ]
})
export class DocumentDownloadModule {}
